import type { TeamPerspectiveSummary } from "~vue/api/generated/team-perspective";
import escapeRegExp from "lodash/escapeRegExp";
import type { ComputedRef, InjectionKey } from "vue";

export const taggableTeamsKey: InjectionKey<ComputedRef<TeamPerspectiveSummary[]>> = Symbol("taggableTeams");

/** Keep matching in sync with coach_core/coach_core/connections/team_names.py:team_name_pattern. */
export function teamNamePattern(name: string): RegExp {
    const pattern = name
        .trim()
        .split(/\s+and\s+|\s*&\s*/iu)
        .map(escapeRegExp)
        .join(String.raw`(?:\s+and\s+|\s*&\s*)`);
    return new RegExp(String.raw`(?<![\p{L}\p{N}\p{M}_])${pattern}(?![\p{L}\p{N}\p{M}_])`, "giu");
}
